import { render, staticRenderFns } from "./Side.vue?vue&type=template&id=d1684fd0&scoped=true"
import script from "./Side.vue?vue&type=script&lang=js"
export * from "./Side.vue?vue&type=script&lang=js"
import style0 from "./Side.vue?vue&type=style&index=0&id=d1684fd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1684fd0",
  null
  
)

export default component.exports